


import axios from "axios";
var config = require('../config/appConfig');

export default function callGetApi(urlStr,headers) {

    return axios.get(config.serverUrl+urlStr, {
        withCredentials: true,
        credentials: "include",
        headers: headers,
        }).then(response => {
                //console.log(response);
                // if(urlStr === '/api/incident/getattachment'){
                //     return response;
                // }else{
                return response.data;
                // }
            }).catch(error => {
                try {
                    if (error.response.status === 401) {
                        //console.log(error);
                    }
                }
                catch (error) {
                    //console.log("error " + (error));
                }
                //console.log('error ' + error);
                return {error: error};
            });
}

